
import { Button } from "@/components/ui/button";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { ArrowRight, Linkedin, Twitter } from "lucide-react";
import { AppointmentForm } from "./AppointmentForm";
import { FooterLinkGrid } from "./FooterLinkGrid";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-50 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-8">
            Adopt the new definition of labor and
            <br />
            schedule a free consultation.
          </h2>
          
          <div className="flex items-center justify-center space-x-4">
            <div className="text-sm text-purple-500 font-medium">
              Ready to build your custom AI solution?
            </div>
            <Dialog>
              <DialogTrigger asChild>
                <Button 
                  className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-2 text-sm font-medium group"
                  aria-label="Schedule a consultation"
                >
                  TALK TO US
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                </Button>
              </DialogTrigger>
              <AppointmentForm />
            </Dialog>
          </div>
        </div>

        {/* Service Links Grid */}
        <div className="border-t border-gray-200 pt-12 pb-12">
          <h3 className="font-semibold text-gray-900 mb-8 text-center text-lg">Our AI Solutions & Services</h3>
          <FooterLinkGrid />
        </div>

        {/* Quick Links */}
        <div className="border-t border-gray-200 pt-8 pb-8">
          <div className="grid md:grid-cols-4 gap-8 text-center md:text-left">
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Company</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-600 hover:text-purple-600 transition-colors">Home</Link></li>
                <li><Link to="/blog" className="text-gray-600 hover:text-purple-600 transition-colors">Blog & Insights</Link></li>
                <li><Link to="/#faq" className="text-gray-600 hover:text-purple-600 transition-colors">FAQ</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-purple-600 transition-colors">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Resources</h4>
              <ul className="space-y-2">
                <li><Link to="/blog" className="text-gray-600 hover:text-purple-600 transition-colors">AI Insights</Link></li>
                <li><Link to="/#services" className="text-gray-600 hover:text-purple-600 transition-colors">Our Services</Link></li>
                <li><a href="/sitemap.xml" className="text-gray-600 hover:text-purple-600 transition-colors">Sitemap</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Legal</h4>
              <ul className="space-y-2">
                <li><Link to="/privacy" className="text-gray-600 hover:text-purple-600 transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-gray-600 hover:text-purple-600 transition-colors">Terms of Service</Link></li>
                <li><Link to="/cookies" className="text-gray-600 hover:text-purple-600 transition-colors">Cookie Policy</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Contact</h4>
              <p className="text-gray-600 text-sm">
                London, United Kingdom<br />
                <a href="mailto:info@orizis.co.uk" className="hover:text-purple-600 transition-colors">
                  info@orizis.co.uk
                </a>
              </p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <img 
                src="/lovable-uploads/e466fd74-54b4-4116-a350-184f20b99347.png" 
                alt="Orizis Logo" 
                className="h-8 w-auto opacity-70 filter grayscale-0 brightness-75"
              />
            </div>
            
            <div className="flex items-center space-x-6 mb-4 md:mb-0">
              <div className="flex space-x-4">
                <a 
                  href="https://www.linkedin.com/company/orizistech" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Follow Orizis on LinkedIn"
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <Linkedin className="h-6 w-6" />
                </a>
                <a 
                  href="https://x.com/orizis" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Follow Orizis on X (Twitter)"
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <Twitter className="h-6 w-6" />
                </a>
              </div>
            </div>
            
            <div className="text-sm text-gray-600">
              © 2024 Orizis AI Studio. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

